import { Component, ViewEncapsulation } from '@angular/core';
import { CardComponent } from '../card/card.component';

@Component({
    selector: 'card-product-category',
    templateUrl: './card-product-category.component.html',
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class CardProductCategoryComponent extends CardComponent {}